
import React from "react";
import Loginslider from '../Login/Loginslider'
import { Link } from "react-router-dom";


export default class SignUp extends React.Component{
    render(){
        return(
            <section className="fxt-template-animation fxt-template-layout29 loaded">
            <div className="container-fluid">
                <div className="row">
                    <div className="vegas-container col-md-7 col-12 p-0">
                    <Loginslider/>
                    <img src="images/org-img/sideimg.png" className="" style={{"transform": "rotate(180deg)"}}/>
                    </div>
                    <div className="col-md-5 col-12 fxt-bg-color">
                        <img src="images/sideimg.png" className="sidepic" />
                        <div className="fxt-content">
                            <div className="fxt-header">
                            <a href="" className="fxt-logo"><img src="images/org-img/logo.png" alt="Logo" style={{ "width": "123px" }} /></a>
                            </div>
                            <div className="fxt-form">
                                <div className="fxt-transformY-50 fxt-transition-delay-1">
                                    <h2>Sign Up</h2>
                                </div>
                                <div className="fxt-transformY-50 fxt-transition-delay-2">
                                <p>Please enter your detail here htmlFor Sign up</p>
                                </div>
                              
                                <form name="POST" >

                                <div className="form-group">
									<div className="fxt-transformY-50 fxt-transition-delay-4">
										<input type="text" className="form-control" name="email" placeholder="Name" required="required"/>
										<i className="fa fa-envelope-o"></i>
									</div>
								</div>
                                <div className="form-group">
									<div className="fxt-transformY-50 fxt-transition-delay-4">
										<input type="text" className="form-control" name="email" placeholder="Company Name" required="required"/>
										<i className="fa fa-user-o"></i>
									</div>
								</div>
                                <div className="form-group">
									<div className="fxt-transformY-50 fxt-transition-delay-4">
										<input type="text" className="form-control" name="email" placeholder="Password" required="required"/>
										<i className="fa fa-eye"></i>
									</div>
								</div>
                                <div className="form-group">
									<div className="fxt-transformY-50 fxt-transition-delay-4">
										<input type="text" className="form-control" name="email" placeholder="Confirm Password" required="required"/>
										<i className="fa fa-eye"></i>
									</div>
								</div>
                                
                                      <div className="form-group">
                                          <div className="fxt-transformY-50 fxt-transition-delay-6">
                                              <div className="fxt-content-between">
                                                  <Link to={'/Otp'} className="fxt-btn-fill">Sign Up</Link>
                                                   </div>
                                          </div>
                                      </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        )
    }
}